
// import React, { useState, forwardRef } from 'react'
// import { Skeleton } from 'antd'
// import { FaInfoCircle } from 'react-icons/fa';
// import FlightOffersTripjack from './FlightOffersTripjack';

// const BookingFilterTripjack = forwardRef(({
//     applyDiscountShow,
//     setApplyDiscountShow,
//     discountAmountOffer,
//     setDiscountAmountOffer,
//     totalAfterDiscount,
//     setTotalAfterDiscount,
//     flightDetails,
//     loading,
//     totalAmount,
//     mealTotalAmount,
//     setCouponId,
//     mealTotalAmountRetrun,
//     totalAmountBaggageReturn,
//     totalBookingPrice,
//     convenienceChargeTotalFareModal,
//     calculatedFee,
//     totalSeatPrice,
//     totalSeatsPriceReturn

// }, ref) => {

//     let getUser = JSON.parse(localStorage.getItem('user'));
//     let tokenId = JSON.parse(localStorage.getItem("tokenId"));
//     const [appliedCheckLogin, setAppliedCheckLogin] = useState("");
//     const [isValidCoupon, setValidCoupon] = useState(null);
//     const [isCongratulations, setIsCongratulations] = useState(null);
//     const [errorMessage, setErrorMessage] = useState("");

//     const applyDiscount = () => {
//         setCouponId(null);
//         if (appliedCheckLogin?.type === "CASHBACK_OFFER") {
//             let discountAmountOffer = 0;
//             let totalAfterDiscounts = totalAmount;

//             if (appliedCheckLogin?.discountType === "PERCENTAGE") {
//                 discountAmountOffer =
//                     (totalAmount * (appliedCheckLogin?.discount || 0)) / 100;
//                 if (discountAmountOffer < user_reward_points) {
//                     totalAfterDiscounts = totalAmount - discountAmountOffer;
//                     setCouponId(appliedCheckLogin?.id);
//                     setApplyDiscountShow(true);
//                     setIsCongratulations(true);
//                     setValidCoupon(null);

//                     setDiscountAmountOffer(discountAmountOffer);
//                     setTotalAfterDiscount(totalAfterDiscount);
//                 } else {
//                     setApplyDiscountShow(false);
//                     setIsCongratulations(false);
//                     setCouponId(null);
//                     setValidCoupon(
//                         "We’re sorry, but it seems your account balance is insufficient to redeem this coupon."
//                     );
//                 }
//             } else if (appliedCheckLogin?.discountType === "AMOUNT") {
//                 discountAmountOffer = appliedCheckLogin?.discount || 0;
//                 if (discountAmountOffer < user_reward_points) {
//                     totalAfterDiscount = totalAmount - discountAmountOffer;
//                     setCouponId(appliedCheckLogin?.id);
//                     setApplyDiscountShow(true);
//                     setIsCongratulations(true);
//                     setValidCoupon(null);
//                     setDiscountAmountOffer(discountAmountOffer);
//                     setTotalAfterDiscount(totalAfterDiscount);
//                 } else {
//                     setCouponId(null);
//                     setApplyDiscountShow(false);
//                     setIsCongratulations(false);
//                     setValidCoupon(null);
//                     setValidCoupon(
//                         "We’re sorry, but it seems your account balance is insufficient to redeem this coupon."
//                     );
//                 }
//             }
//         } else {
//             const totalAmount = Math.round(totalBookingPrice);
//             let discountAmountOffer = 0;
//             let totalAfterDiscount = totalAmount;

//             if (appliedCheckLogin?.discountType === "PERCENTAGE") {
//                 discountAmountOffer =
//                     (totalAmount * (appliedCheckLogin?.discount || 0)) / 100;
//                 totalAfterDiscount = totalAmount - discountAmountOffer;
//             } else if (appliedCheckLogin?.discountType === "AMOUNT") {
//                 discountAmountOffer = appliedCheckLogin?.discount || 0;
//                 totalAfterDiscount = totalAmount - discountAmountOffer;
//             }
//             setApplyDiscountShow(true);
//             setIsCongratulations(true);
//             setCouponId(appliedCheckLogin?.id);
//             setDiscountAmountOffer(discountAmountOffer);
//             setTotalAfterDiscount(totalBookingPrice);
//         }
//     };

//     let finalAmountPay = totalBookingPrice + calculatedFee - discountAmountOffer;

//     return (
//         <>
//             <div className="booking-filter sticky-cls-top">
//                 <Skeleton
//                     paragraph={{ rows: 6, }}
//                     loading={loading}
//                     style={{ background: "#fff" }}
//                     className='p-4 mb-4'
//                 >
//                     <div className='card'>
//                         <div className="card-body">
//                             <h3 className="mb-3 fw-bold">Payment Details</h3>
//                             <ul className="price-details list-unstyled">

//                                 {flightDetails?.searchQuery?.paxInfo?.ADULT > 0 && (
//                                     <li className="d-flex justify-content-between">
//                                         <div> <span>{flightDetails.searchQuery.paxInfo.ADULT === 1 ? "Adult" : "Adults"} </span>({flightDetails.searchQuery.paxInfo.ADULT} X ₹{flightDetails?.priceBreakup?.ADULT_BF || 0})</div>
//                                         <span>₹{(flightDetails?.priceBreakup?.ADULT_BF || 0) * flightDetails.searchQuery.paxInfo.ADULT}</span>
//                                     </li>
//                                 )}

//                                 {flightDetails?.searchQuery?.paxInfo?.CHILD > 0 && (
//                                     <li className="d-flex justify-content-between">
//                                         <div><span>{flightDetails.searchQuery.paxInfo.CHILD === 1 ? "Child" : "Children"}</span> ({flightDetails.searchQuery.paxInfo.CHILD} X ₹{flightDetails?.priceBreakup?.CHILD_BF || 0})</div>
//                                         <span>₹{(flightDetails?.priceBreakup?.CHILD_BF || 0) * flightDetails.searchQuery.paxInfo.CHILD}</span>
//                                     </li>
//                                 )}

//                                 {flightDetails?.searchQuery?.paxInfo?.INFANT > 0 && (
//                                     <li className="d-flex justify-content-between">
//                                         <div><span>{flightDetails.searchQuery.paxInfo.CHILD === 1 ? "Infant" : "Infants"} </span>({flightDetails.searchQuery.paxInfo.INFANT} X ₹{flightDetails?.priceBreakup?.INFANT_BF || 0})</div>
//                                         <span>₹{(flightDetails?.priceBreakup?.INFANT_BF || 0) * flightDetails.searchQuery.paxInfo.INFANT}</span>
//                                     </li>
//                                 )}

//                                 <li className="d-flex justify-content-between">
//                                     <span>Fee & Surcharges</span>
//                                     <span>₹{Math.round(flightDetails?.priceBreakup?.ServiceTax || 0)}</span>
//                                 </li>

//                                 {(mealTotalAmount > 0 || mealTotalAmountRetrun > 0) && (
//                                     <li className='d-flex justify-content-between'>
//                                         Meal  <span>₹{mealTotalAmount + mealTotalAmountRetrun}</span>
//                                     </li>
//                                 )}

//                                 {(totalAmount > 0 || totalAmountBaggageReturn > 0) && (
//                                     <li className='d-flex justify-content-between'>
//                                         Baggage <span>₹{totalAmount + totalAmountBaggageReturn}</span>
//                                     </li>
//                                 )}

//                                 {(totalSeatPrice > 0 || totalSeatsPriceReturn > 0) && (
//                                     <li className='d-flex justify-content-between'>
//                                         Seats <span>₹{totalSeatPrice + totalSeatsPriceReturn}</span>
//                                     </li>
//                                 )}

//                                 {applyDiscountShow && discountAmountOffer > 0 && (
//                                     <li className="d-flex justify-content-between">
//                                         Discount <span className="text-danger">₹{Math.round(discountAmountOffer)}</span>
//                                     </li>
//                                 )}

//                             </ul>
//                             <div className="text-center mt-3 bg-light-success p-2 rounded">
//                                 {!applyDiscountShow ? (
//                                     <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{Math.round(totalBookingPrice)}</span></h3></>) : (
//                                     <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{Math.round(totalBookingPrice - discountAmountOffer)}</span></h3></>
//                                 )}
//                             </div>
//                         </div>
//                     </div>

//                     {(!tokenId || getUser?.reward_point <= "0.00") &&
//                         <div className='card mb-2'>
//                             <div className="card-header py-3">
//                                 <h3 className='mb-2 fw-bold'>Exclusive Cashback for New Users</h3>
//                                 <ul className='price-details'>
//                                     <li className="d-flex align-items-center justify-content-between">
//                                         <p>Reward Points</p>
//                                         <h2 className=' d-flex align-items-center mt-1'>
//                                             <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" className='me-1' fill='var(--primary-color) !important'>
//                                                 <g id="SVGRepo_bgCarrier" strokeWidth="0" />
//                                                 <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
//                                                 <g id="SVGRepo_iconCarrier">
//                                                     <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" />
//                                                 </g>
//                                             </svg>

//                                             {!convenienceChargeTotalFareModal ? (
//                                                 Math.round(totalBookingPrice - Number(discountAmountOffer))
//                                             ) : (
//                                                 Math.round(finalAmountPay)
//                                             )}
//                                         </h2>
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>
//                     }

//                 </Skeleton>

//                 <Skeleton
//                     paragraph={{ rows: 6, }}
//                     loading={loading}
//                     style={{ background: "#fff" }}
//                     className='p-4 mb-4'
//                 >

//                     <FlightOffersTripjack
//                         ref={ref}
//                         totalBookingPrice={totalBookingPrice}
//                         setDiscountAmountOffer={setDiscountAmountOffer}
//                         setErrorMessage={setErrorMessage}
//                         errorMessage={errorMessage}
//                         appliedCheckLogin={appliedCheckLogin}
//                         setAppliedCheckLogin={setAppliedCheckLogin}
//                         applyDiscount={applyDiscount}
//                         totalAfterDiscount={totalAfterDiscount}
//                         setApplyDiscountShow={setApplyDiscountShow}
//                         applyDiscountShow={applyDiscountShow}
//                         isCongratulations={isCongratulations}
//                         setIsCongratulations={setIsCongratulations}
//                         isValidCoupon={isValidCoupon}
//                         setValidCoupon={setValidCoupon}
//                     />
//                 </Skeleton>

//             </div>
//         </>
//     );
// });

// export default BookingFilterTripjack

import React, { useState, forwardRef } from 'react'
import { Skeleton } from 'antd'
import { FaInfoCircle, FaPlus, FaMinus } from 'react-icons/fa';
import FlightOffersTripjack from './FlightOffersTripjack';

const BookingFilterTripjack = forwardRef(({
    applyDiscountShow,
    setApplyDiscountShow,
    discountAmountOffer,
    setDiscountAmountOffer,
    totalAfterDiscount,
    setTotalAfterDiscount,
    flightDetails,
    loading,
    totalAmount,
    mealTotalAmount,
    setCouponId,
    mealTotalAmountRetrun,
    totalAmountBaggageReturn,
    totalBookingPrice,
    convenienceChargeTotalFareModal,
    calculatedFee,
    totalSeatPrice,
    totalSeatsPriceReturn

}, ref) => {

    let getUser = JSON.parse(localStorage.getItem('user'));
    let tokenId = JSON.parse(localStorage.getItem("tokenId"));
    const [appliedCheckLogin, setAppliedCheckLogin] = useState("");
    const [isValidCoupon, setValidCoupon] = useState(null);
    const [isCongratulations, setIsCongratulations] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

    // State for collapsible sections
    const [showBaseFare, setShowBaseFare] = useState(false);
    const [showTaxes, setShowTaxes] = useState(false);
    const [showServices, setShowServices] = useState(false);
    const [selectedCode, setSelectedCode] = useState("");
    const applyDiscount = () => {
        setCouponId(null);
        if (appliedCheckLogin?.type === "CASHBACK_OFFER") {
            let discountAmountOffer = 0;
            let totalAfterDiscounts = totalAmount;

            if (appliedCheckLogin?.discountType === "PERCENTAGE") {
                discountAmountOffer =
                    (totalAmount * (appliedCheckLogin?.discount || 0)) / 100;
                if (discountAmountOffer < user_reward_points) {
                    totalAfterDiscounts = totalAmount - discountAmountOffer;
                    setCouponId(appliedCheckLogin?.id);
                    setApplyDiscountShow(true);
                    setIsCongratulations(true);
                    setValidCoupon(null);

                    setDiscountAmountOffer(discountAmountOffer);
                    setTotalAfterDiscount(totalAfterDiscount);
                } else {
                    setApplyDiscountShow(false);
                    setIsCongratulations(false);
                    setCouponId(null);
                    setValidCoupon(
                        "We're sorry, but it seems your account balance is insufficient to redeem this coupon."
                    );
                }
            } else if (appliedCheckLogin?.discountType === "AMOUNT") {
                discountAmountOffer = appliedCheckLogin?.discount || 0;
                if (discountAmountOffer < user_reward_points) {
                    totalAfterDiscount = totalAmount - discountAmountOffer;
                    setCouponId(appliedCheckLogin?.id);
                    setApplyDiscountShow(true);
                    setIsCongratulations(true);
                    setValidCoupon(null);
                    setDiscountAmountOffer(discountAmountOffer);
                    setTotalAfterDiscount(totalAfterDiscount);
                } else {
                    setCouponId(null);
                    setApplyDiscountShow(false);
                    setIsCongratulations(false);
                    setValidCoupon(null);
                    setValidCoupon(
                        "We're sorry, but it seems your account balance is insufficient to redeem this coupon."
                    );
                }
            }
        } else {
            const totalAmount = Math.round(totalBookingPrice);
            let discountAmountOffer = 0;
            let totalAfterDiscount = totalAmount;

            if (appliedCheckLogin?.discountType === "PERCENTAGE") {
                discountAmountOffer =
                    (totalAmount * (appliedCheckLogin?.discount || 0)) / 100;
                totalAfterDiscount = totalAmount - discountAmountOffer;
            } else if (appliedCheckLogin?.discountType === "AMOUNT") {
                discountAmountOffer = appliedCheckLogin?.discount || 0;
                totalAfterDiscount = totalAmount - discountAmountOffer;
            }
            setApplyDiscountShow(true);
            setIsCongratulations(true);
            setCouponId(appliedCheckLogin?.id);
            setDiscountAmountOffer(discountAmountOffer);
            setTotalAfterDiscount(totalBookingPrice);
        }
    };

    let finalAmountPay = totalBookingPrice + calculatedFee - discountAmountOffer;

    const [showDiscount, setShowDiscount] = useState(false);

    return (
        <>
            <div className="booking-filter sticky-cls-top">
                <Skeleton
                    paragraph={{ rows: 6, }}
                    loading={loading}
                    style={{ background: "#fff" }}
                    className='p-4 mb-4'
                >
                    <div className='card'>
                        <div className="card-body">
                            <h3 className="mb-3 fw-bold">Payment Details</h3>
                            <ul className="price-details list-unstyled">

                                {/* Base Fare Section */}
                                <li className="fare-section">
                                    <div
                                        className="fare-header d-flex justify-content-between align-items-center cursor-pointer py-2"
                                        onClick={() => setShowBaseFare(!showBaseFare)}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className={`me-2 ${showBaseFare ? 'text-primary' : ''}`}>
                                                {showBaseFare ? <FaMinus size={12} /> : <FaPlus size={12} />}
                                            </span>
                                            <span>Base Fare</span>
                                        </div>
                                        <span>
                                            ₹{(
                                                (flightDetails?.priceBreakup?.ADULT_BF || 0) * (flightDetails?.searchQuery?.paxInfo?.ADULT || 0) +
                                                (flightDetails?.priceBreakup?.CHILD_BF || 0) * (flightDetails?.searchQuery?.paxInfo?.CHILD || 0) +
                                                (flightDetails?.priceBreakup?.INFANT_BF || 0) * (flightDetails?.searchQuery?.paxInfo?.INFANT || 0)
                                            )}
                                        </span>
                                    </div>

                                    {showBaseFare && (
                                        <div className="fare-details ps-4 mt-2">
                                            {flightDetails?.searchQuery?.paxInfo?.ADULT > 0 && (
                                                <div className="d-flex justify-content-between py-1">
                                                    <div>
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>{flightDetails.searchQuery.paxInfo.ADULT === 1 ? "Adult" : "Adults"} </span>
                                                        ({flightDetails.searchQuery.paxInfo.ADULT} X ₹{flightDetails?.priceBreakup?.ADULT_BF || 0})
                                                    </div>
                                                    <span style={{ fontSize: "14px", fontWeight: "400" }}>₹{(flightDetails?.priceBreakup?.ADULT_BF || 0) * flightDetails.searchQuery.paxInfo.ADULT}</span>
                                                </div>
                                            )}

                                            {flightDetails?.searchQuery?.paxInfo?.CHILD > 0 && (
                                                <div className="d-flex justify-content-between py-1">
                                                    <div>
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>{flightDetails.searchQuery.paxInfo.CHILD === 1 ? "Child" : "Children"}</span>
                                                        ({flightDetails.searchQuery.paxInfo.CHILD} X ₹{flightDetails?.priceBreakup?.CHILD_BF || 0})
                                                    </div>
                                                    <span style={{ fontSize: "14px", fontWeight: "400" }}>₹{(flightDetails?.priceBreakup?.CHILD_BF || 0) * flightDetails.searchQuery.paxInfo.CHILD}</span>
                                                </div>
                                            )}

                                            {flightDetails?.searchQuery?.paxInfo?.INFANT > 0 && (
                                                <div className="d-flex justify-content-between py-1">
                                                    <div>
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>{flightDetails.searchQuery.paxInfo.INFANT === 1 ? "Infant" : "Infants"} </span>
                                                        ({flightDetails.searchQuery.paxInfo.INFANT} X ₹{flightDetails?.priceBreakup?.INFANT_BF || 0})
                                                    </div>
                                                    <span style={{ fontSize: "14px", fontWeight: "400" }}>₹{(flightDetails?.priceBreakup?.INFANT_BF || 0) * flightDetails.searchQuery.paxInfo.INFANT}</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </li>

                                {/* Taxes and Surcharges Section */}
                                <li className="fare-section">
                                    <div
                                        className="fare-header d-flex justify-content-between align-items-center cursor-pointer py-2"
                                        onClick={() => setShowTaxes(!showTaxes)}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className={`me-2 ${showTaxes ? 'text-primary' : ''}`}>
                                                {showTaxes ? <FaMinus size={12} /> : <FaPlus size={12} />}
                                            </span>
                                            <span>Fee & Surcharges</span>
                                        </div>
                                        <span>₹{Math.round(flightDetails?.priceBreakup?.ServiceTax || 0)}</span>
                                    </div>

                                    {showTaxes && (
                                        <div className="fare-details ps-2 mt-2">
                                            <div className="d-flex justify-content-between py-1">
                                                <span style={{ fontSize: "14px", fontWeight: "400" }}>Airline Taxes and Surcharges</span>
                                                <span>₹{Math.round(flightDetails?.priceBreakup?.ServiceTax || 0)}</span>
                                            </div>
                                        </div>
                                    )}
                                </li>

                                {/* Other Services Section */}
                                {(mealTotalAmount > 0 || mealTotalAmountRetrun > 0 || totalAmount > 0 || totalAmountBaggageReturn > 0 || totalSeatPrice > 0 || totalSeatsPriceReturn > 0) && (
                                    <li className="fare-section">
                                        <div
                                            className="fare-header d-flex justify-content-between align-items-center cursor-pointer py-2"
                                            onClick={() => setShowServices(!showServices)}
                                        >
                                            <div className="d-flex align-items-center">
                                                <span className={`me-2 ${showServices ? 'text-primary' : ''}`}>
                                                    {showServices ? <FaMinus size={12} /> : <FaPlus size={12} />}
                                                </span>
                                                <span>Other Services</span>
                                            </div>
                                            <span>
                                                ₹{(mealTotalAmount + mealTotalAmountRetrun) +
                                                    (totalAmount + totalAmountBaggageReturn) +
                                                    (totalSeatPrice + totalSeatsPriceReturn)}
                                            </span>
                                        </div>

                                        {showServices && (
                                            <div className="fare-details ps-4 mt-2">
                                                {(mealTotalAmount > 0 || mealTotalAmountRetrun > 0) && (
                                                    <div className='d-flex justify-content-between py-1'>
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>Meal</span>
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>₹{mealTotalAmount + mealTotalAmountRetrun}</span>
                                                    </div>
                                                )}

                                                {(totalAmount > 0 || totalAmountBaggageReturn > 0) && (
                                                    <div className='d-flex justify-content-between py-1'>
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>Baggage</span>
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>₹{totalAmount + totalAmountBaggageReturn}</span>
                                                    </div>
                                                )}

                                                {(totalSeatPrice > 0 || totalSeatsPriceReturn > 0) && (
                                                    <div className='d-flex justify-content-between py-1'>
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>Seats</span>
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>₹{totalSeatPrice + totalSeatsPriceReturn}</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </li>
                                )}

                                {/* {applyDiscountShow && discountAmountOffer > 0 && (
                                    <li className="d-flex justify-content-between py-2">
                                        <span>Discount</span>
                                        <span className="text-danger">-₹{Math.round(discountAmountOffer)}</span>
                                    </li>
                                )} */}
                                {applyDiscountShow && discountAmountOffer > 0 && (
                                    <li className="fare-section">
                                        <div
                                            className="fare-header d-flex justify-content-between align-items-center cursor-pointer py-2"
                                            onClick={() => setShowDiscount(!showDiscount)}
                                        >
                                            <div className="d-flex align-items-center">
                                                <span className={`me-2 ${showDiscount ? 'text-primary' : ''}`}>
                                                    {showDiscount ? <FaMinus size={12} /> : <FaPlus size={12} />}
                                                </span>
                                                <span className="text-danger">Discount</span>
                                            </div>
                                            <span className="text-danger">-₹{Math.round(discountAmountOffer)}</span>
                                        </div>

                                        {showDiscount && (
                                            <div className="fare-details ps-4 mt-2">
                                                <div className="d-flex justify-content-between py-1">
                                                    <div className="d-flex align-items-center">
                                                        <span style={{ fontSize: "14px", fontWeight: "400" }} className="me-2">{selectedCode}</span>
                                                    </div>
                                                    <span style={{ fontSize: "14px", fontWeight: "400" }} className="text-danger">-₹{discountAmountOffer}</span>
                                                </div>
                                            </div>
                                        )}
                                    </li>
                                )}


                            </ul>
                            <div className="text-center mt-3 bg-light-success p-2 rounded">
                                {!applyDiscountShow ? (
                                    <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{Math.round(totalBookingPrice)}</span></h3></>) : (
                                    <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{Math.round(totalBookingPrice - discountAmountOffer)}</span></h3></>
                                )}
                            </div>
                        </div>
                    </div>

                    {(!tokenId || getUser?.reward_point <= "0.00") &&
                        <div className='card mb-2'>
                            <div className="card-header py-3">
                                <h3 className='mb-2 fw-bold'>Exclusive Cashback for New Users</h3>
                                <ul className='price-details'>
                                    <li className="d-flex align-items-center justify-content-between">
                                        <p>Reward Points</p>
                                        <h2 className=' d-flex align-items-center mt-1'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" className='me-1' fill='var(--primary-color) !important'>
                                                <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                                <g id="SVGRepo_iconCarrier">
                                                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" />
                                                </g>
                                            </svg>

                                            {!convenienceChargeTotalFareModal ? (
                                                Math.round(totalBookingPrice - Number(discountAmountOffer))
                                            ) : (
                                                Math.round(finalAmountPay)
                                            )}
                                        </h2>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    }

                </Skeleton>

                <Skeleton
                    paragraph={{ rows: 6, }}
                    loading={loading}
                    style={{ background: "#fff" }}
                    className='p-4 mb-4'
                >

                    <FlightOffersTripjack
                        ref={ref}
                        totalBookingPrice={totalBookingPrice}
                        setDiscountAmountOffer={setDiscountAmountOffer}
                        setErrorMessage={setErrorMessage}
                        errorMessage={errorMessage}
                        appliedCheckLogin={appliedCheckLogin}
                        setAppliedCheckLogin={setAppliedCheckLogin}
                        applyDiscount={applyDiscount}
                        totalAfterDiscount={totalAfterDiscount}
                        setApplyDiscountShow={setApplyDiscountShow}
                        applyDiscountShow={applyDiscountShow}
                        isCongratulations={isCongratulations}
                        setIsCongratulations={setIsCongratulations}
                        isValidCoupon={isValidCoupon}
                        setValidCoupon={setValidCoupon}
                        selectedCode={selectedCode}
                        setSelectedCode={setSelectedCode}
                    />
                </Skeleton>

            </div>
        </>
    );
});

export default BookingFilterTripjack